<button class="tw:hidden tw:md:flex tw:items-center tw:bg-transparent tw:border-none tw:gap-2">
	<mat-icon class="tw:text-secondary!">language</mat-icon>
	<span class="tw:text-base tw:font-medium">English</span>
</button>
